import { useEffect, useState } from "react";
import UseWindowSize from "../UseWindowSize";

type PromoBannerProps = {
  img: string;
  alt?: string;
};

const PromoBanner = ({ img, alt }: PromoBannerProps) => {
  const { width } = UseWindowSize();
  const [winSize, setWinSize] = useState(null);

  useEffect(() => {
    setWinSize(width);
  });

  return (
    <>
      <div className="detail-promo-banner">
        <img
          src={img + "?w=" + winSize * 1.2}
          alt={alt ? alt : "detail-promo-banner"}
        />
      </div>
      <style jsx>{`
        .detail-promo-banner {
          height: auto;
        }
        .detail-promo-banner img {
          width: 100%;
          height: 100%;
          min-height: 120px;
        }
      `}</style>
    </>
  );
};

export default PromoBanner;
